import { getIdToken } from "../auth/authService";

const getApiUrl = () =>
  process.env.REACT_APP_ENV === "PROD"
    ? process.env.REACT_APP_API_URL_PROD
    : process.env.REACT_APP_API_URL_DEV;

export const authenticatedFetch = async (path, options = {}) => {
  const apiUrl = getApiUrl();
  if (!apiUrl) {
    throw new Error(
      "API URL not found. Set REACT_APP_API_URL_DEV or REACT_APP_API_URL_PROD."
    );
  }

  const { skipAuth = false, headers, ...rest } = options;
  const requestHeaders = new Headers(headers);

  if (!requestHeaders.has("Content-Type") && rest.body) {
    requestHeaders.set("Content-Type", "application/json");
  }

  if (!skipAuth) {
    const accessToken = await getIdToken();
    if (!accessToken) {
      throw new Error("Not authenticated");
    }
    requestHeaders.set("Authorization", `Bearer ${accessToken}`);
  }

  return fetch(`${apiUrl}${path}`, {
    ...rest,
    headers: requestHeaders,
  });
};

export { getApiUrl };
